<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport")
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="report.length")
      .card.my-2
        .card-body
          table.table.table-striped.table-responsive
            thead
              tr
                th Fiscal
                th.text-right Andamento
                th.text-right Distribuição
                th.text-right Total
            tbody
              tr(v-for="item in report")
                td {{ item.fiscal }}
                td.text-right {{ item.andamento }}
                td.text-right {{ item.em_distribuicao }}
                td.text-right {{ item.q }}
            tfoot.text-bold
              tr
                td Total
                td.text-right {{ totais.andamento }}
                td.text-right {{ totais.em_distribuicao }}
                td.text-right {{ totais.q }}
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas OS-m neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import ordemServicos from "@/api/indicadores/ordemServicos"
import FormFilter from "./components/Filter"

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    totais() {
      return this.report.reduce(
        (t, item) => {
          return {
            q: t.q + Number(item.q),
            andamento: t.andamento + Number(item.andamento),
            em_distribuicao: t.em_distribuicao + Number(item.em_distribuicao),
          }
        },
        {
          andamento: 0,
          em_distribuicao: 0,
          q: 0,
        },
      )
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await ordemServicos.fiscaisAndamentoDistribuicao({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
